function isSet(value) {
    return value instanceof Set;
}

export { isSet };
